
<style>
.news-card {
  position: relative;
  display: block;
  height: 320px;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.news-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 35px rgba(0,0,0,0.25);
}

.news-card-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: transform 0.5s ease;
}

.news-card:hover .news-card-bg {
  transform: scale(1.1);
}

.news-card-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    rgba(0,0,0,0.75),
    rgba(0,0,0,0.15)
  );
}

.news-card-content {
  position: absolute;
  bottom: 0;
  padding: 20px;
  color: #fff;
  z-index: 2;
}

.news-card-title {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 5px;
}

.news-card-date {
  font-size: 0.85rem;
  opacity: 0.85;
}

</style>

<template>
  <div class="underLogoPhrase">
    <h2 class="font-weight-bold mb-5 centers">Les Actualités</h2>
  </div>

<div class="container my-5">
  <div class="row g-5"> <!-- 🔥 espace entre les cards -->

    <div
      class="col-12 col-sm-6 col-lg-4"
      v-for="actu in news"
      :key="actu.id"
    >
      <router-link
        :to="'/publication/' + actu.id"
        class="news-card"
      >
        <!-- Image -->
        <div
          class="news-card-bg"
          :style="actu.image
            ? { backgroundImage: `url('https://admin.asso-refuge.fr/images/${actu.image}')` }
            : { backgroundColor: '#ccc' }
          "
        ></div>

        <!-- Date -->


        <!-- Titre -->
        <div class="news-card-title">
          {{ actu.nom }}
        </div>
      </router-link>
    </div>

  </div>
</div>

</template>
<script>
export default {
  data() {
    return {
      news: []
    };
  },
  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(response => response.json())
      .then(data => {
        this.news = data || [];
      })
      .catch(error => {
        console.error('Erreur getNews:', error.message);
      });
  }
};
</script>